import React, { useEffect, useState, createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from 'components/MDBox';
import { useLocation } from 'react-router-dom';
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import SearchAppScheduleReq from '../../../../Classes/Models/Requests/Appointments/SearchAppScheduleReq';
import Swal from 'sweetalert2';
import AddTherapistToDay from '../../AppointmentDays/AppointmentDayDetails/AddTherapistToDay';
import AppDayTableSimple from './AppDayTableSimple';
import { useContext } from 'react';
import { UserContext } from 'App';
import CopyDayCard from './CopyDayCard';
import "./AppDay.scss";
import { LanguageContext } from "App";
import Loader from 'layouts/loader/loader';
import ConnectionService from 'Classes/ConnectionService';
import { ConnectionContext } from 'App';

const index = () => {
    const User = useContext(UserContext)

    const { state } = useLocation();
    const {translations, switchLanguage} = useContext(LanguageContext)
    const ConnectionService = useContext(ConnectionContext);
    const [IsLoaded, setIsLoaded] = useState(false)
    const [AppDay, setAppDay] = useState({})
    const [ShowCopyDay, setShowCopyDay] = useState(false);
    const [ShowAddTherapist, setShowAddTherapist] = useState(false);
    const [checkedDays, setCheckedDays] = useState([]);
    const [DayPartitionNumber, setDayPartitionNumber] = useState(2);
    const [AppDayAutoUpdate, setAppDayAutoUpdate] = useState(null);



    useEffect(async () => {
        if (!IsLoaded) {
            await GetAppDayById(state.AppDay.id, DayPartitionNumber);
        }

    }, [IsLoaded])

    useEffect(async () => {
        if(ConnectionService == null) {
            return
        }
        // Pass the callback function to the connection service
        ConnectionService.handleAppointmentDayUpdate =  autoUpdateDay;
    }, [ConnectionService])



    const autoUpdateDay = async (AppHourId) => {
        // let req = new SearchStringOrIntReq();
        // req.SearchInt = state.AppDay.id;
        // req.HoursIndex = DayPartitionNumber; 
        // let currentAppDay = await AppointmentsApi.GetAppoinmentDayByIdIndexed(req);

        // if (currentAppDay && currentAppDay.data && Array.isArray(currentAppDay.data.getTherapists)) {
        //     for (let i = 0; i < currentAppDay.data.getTherapists.length; i++) {
        //         console.log("2.  ", currentAppDay.data.getTherapists.length);
        //         if (Array.isArray(currentAppDay.data.getTherapists[i].getAppointmentHours)) {
        //             for (let j = 0; j < currentAppDay.data.getTherapists[i].getAppointmentHours.length; j++) {
        //                 if (currentAppDay.data.getTherapists[i].getAppointmentHours[j].id == AppHourId) {
        //                     await GetAppDayById(state.AppDay.id, DayPartitionNumber);
        //                 }
        //             }
        //         } else {
        //             console.error(`getAppointmentHours is not an array for therapist at index ${i}`);
        //         }
        //     }
        // } else {
        //     console.error("currentAppDay.data.getTherapists is not an array or is undefined.");
        // }

        // console.log("Got AUTO UPDATE DAY DONE")
    }



    useEffect(() => {
        if (Object.keys(AppDay).length > 0) {
            setIsLoaded(true);
        }
        else {
            setIsLoaded(false);
        }

    }, [AppDay])


    const GetAppDayById = async (Id, HoursIndex) => {
        // setIsLoaded(false);
        if(HoursIndex == null){
            HoursIndex = DayPartitionNumber;
        }
        console.log("GETTING DAY BY ID")
        let req = new SearchAppScheduleReq();
        req.SearchInt = Id;
        req.HoursIndex = HoursIndex;
 
        try{
            
        
        let res = await AppointmentsApi.GetAppoinmentDayByIdIndexed(req);
        console.log(res)

        // res.data?.getTherapists?.forEach(therapist => {
        //     if (therapist && therapist.getAppointmentHours) {
        //         therapist.getAppointmentHours.forEach(hour => {
        //             if (hour && hour.getListedAccountingSessions.length > 0) {
        //                 hour.getListedAccountingSessions.forEach(session => {
        //                     if (session && !session.isAdmitted && !session.isAbsent) {
        //                         checkedDays.push("Therapist: " + hour.therapistName + ' <br> '
        //                             + "Session Name: " + session.sessionName + ' <br> '
        //                             + "At: " + hour.appointmentHourTime + ' <br> '
        //                             + "Patient Name: " + session.patientName + ' <br> '
        //                             + "Session is not admitted"
        //                         );

        //                     }
        //                 });
        //             }
        //         });
        //     }
        // });

        // setCheckedDays(checkedDays);

        if (res.status == "Success") {
            setAppDay(res.data)
            if(AppDayAutoUpdate == null) {
                setAppDayAutoUpdate(res.data)
            }
        }
        else {
            Swal.fire("Failed", res.message, "error");
        }
        return res
        } catch (error) {
            console.error("Error fetching data:", error);
            Swal.fire("Failed", "An error occurred while fetching data", "error");
        } finally {
            setIsLoaded(true)
        }
    }

    if (!IsLoaded && Object.keys(AppDay).length == 0) {
        return (
            <div>
                <Loader/>
            </div>
        )
    }
    return (
        <div className="AppDayIndex">

           
           
                <AppDayTableSimple AppDay={AppDay} setAppDay={setAppDay}
                setIsLoaded={setIsLoaded} GetAppDayById={GetAppDayById}
                id={state.AppDay.id}
                DayPartitionNumber={DayPartitionNumber} setDayPartitionNumber={setDayPartitionNumber}
                IsLoaded={IsLoaded} setShowCopyDay={setShowCopyDay} ShowCopyDay={ShowCopyDay}
                setShowAddTherapist={setShowAddTherapist} ShowAddTherapist={ShowAddTherapist} checkedDays={checkedDays} />
              
              
      
        </div>
    )
}

export default index